export default class NewsPageHero {
    constructor(elm) {
        const newsPageHeroMedia = elm.querySelector('.news-article-page__hero__media.long-video');
        const btnVideoContainer = elm.querySelector('.btn-video-container');

        function placePlaybutton() {
            if (btnVideoContainer !== null) {
                newsPageHeroMedia.prepend(btnVideoContainer);
                newsPageHeroMedia.style.position = 'relative';
                btnVideoContainer.style.position = 'absolute';
                btnVideoContainer.style.top = '50%';
                btnVideoContainer.style.left = '50%';
                btnVideoContainer.style.transform = 'translate(-50%, -50%)';
            }
        }

        placePlaybutton();
    }
}
